import {ListingSlat} from "@hosttools/frontend";
import {type Listing} from "@hosttools/frontend/models/listing";
import {type CellContext} from "@tanstack/react-table";
import type React from "react";
import {memo} from "react";

const TableThumbnailColumn: React.FC<CellContext<Listing, string>> = props => {
    return <ListingSlat includeChannel={false} listing={props.row.original} size="sm" />;
};

export default memo(TableThumbnailColumn);
